module.exports = __webpack_public_path__ + "img/ETSPVia.4a196c07.svg";